export const BOTTLE_WEBSITE_URL = 'https://bottle.com'
